import React, { useCallback, useEffect, useState } from 'react';
import { useApiCaller } from '../../utils/ApiUtilities';
import { getSuperAdminAdminsUrl } from '../../utils/UrlUtilities';
import { formatBdPst } from '../../utils/DateUtilities';
import AdminCreateForm from './AdminCreateForm';
import AdminEditProfileForm from './AdminEditProfileForm';
import CloseButton from '../ui/CloseButton';

function Modal({ title, children, onClose }) {
    return (
        <>
            <div
                className="modal fade show d-block"
                tabIndex="-1"
                role="dialog"
                style={{ background: 'rgba(0,0,0,0.4)' }}
                onClick={onClose}
            >
                <div
                    className="modal-dialog"
                    role="document"
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{title}</h5>
                            <CloseButton onClick={onClose} />
                        </div>
                        <div className="modal-body">{children}</div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default function AdminListGrid() {
    const [admins, setAdmins] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showCreate, setShowCreate] = useState(false);
    const [editing, setEditing] = useState(null);
    const CallApi = useApiCaller();

    const reload = useCallback(async () => {
        setLoading(true);
        const res = await CallApi({ url: getSuperAdminAdminsUrl(), method: 'GET' });
        if (res.success) setAdmins(res.data || []);
        setLoading(false);
    }, [CallApi]);

    useEffect(() => {
        reload();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="mb-0">Admins ({admins.length})</h4>
                <button className="btn btn-success" onClick={() => setShowCreate(true)}>
                    + Add Admin
                </button>
            </div>
            {loading ? (
                <div>Loading…</div>
            ) : (
                <div className="table-responsive">
                    <table className="table table-bordered table-hover align-middle">
                        <thead className="table-light">
                            <tr>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Status</th>
                                <th>Total Questions</th>
                                <th>Last Question At</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {admins.length === 0 && (
                                <tr><td colSpan={6} className="text-center text-muted">No admins yet</td></tr>
                            )}
                            {admins.map((a) => (
                                <tr key={a.id}>
                                    <td>{a.name}</td>
                                    <td>{a.email}</td>
                                    <td>
                                        {a.is_active ? (
                                            <span className="badge bg-success">Active</span>
                                        ) : (
                                            <span className="badge bg-secondary">Inactive</span>
                                        )}
                                    </td>
                                    <td>{a.total_questions ?? 0}</td>
                                    <td>{a.last_question_at ? formatBdPst(a.last_question_at) : '—'}</td>
                                    <td>
                                        <button
                                            className="btn btn-sm btn-outline-primary"
                                            onClick={() => setEditing(a)}
                                        >
                                            Edit Profile
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {showCreate && (
                <Modal title="Create Admin" onClose={() => setShowCreate(false)}>
                    <AdminCreateForm
                        onCreated={() => { setShowCreate(false); reload(); }}
                        onCancel={() => setShowCreate(false)}
                    />
                </Modal>
            )}

            {editing && (
                <Modal title={`Edit Profile — ${editing.name}`} onClose={() => setEditing(null)}>
                    <AdminEditProfileForm
                        admin={editing}
                        onUpdated={() => { setEditing(null); reload(); }}
                        onCancel={() => setEditing(null)}
                    />
                </Modal>
            )}
        </div>
    );
}
